import InputGroup from "react-bootstrap/InputGroup";
import Prepend from "./Prepend";
import Form from "react-bootstrap/Form";
import React from "react";

export default function (props) {
    return (
        <InputGroup>
            <Prepend text={props.prependText} icon={props.prependIcon}/>
            <Form.Control
                type={!!props.type ? props.type : "text"}
                value={props.value}
                name={props.name}
                onChange={props.onChange}
                onBlur={props.onBlur}
                isInvalid={!!props.error}
            />
            <Form.Control.Feedback type="invalid">
                {props.error}
            </Form.Control.Feedback>
        </InputGroup>
    )
}
